module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.id) ? _c('v-layout', {
    staticClass: "header-booking-data",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('p', [_vm._v("Gasto Total")]), _vm._v(" "), _c('span', [_vm._v("$" + _vm._s(_vm._f("round")(_vm.totalExpenses)))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-tab",
    class: {
      'active': _vm.$route.name === 'companies-edit'
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goTo('edit')
      }
    }
  }, [_vm._v("\n\t\t\t\tDetalle\n\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-tab",
    class: {
      'active': _vm.$route.name === 'companies-statistics'
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goTo('statistics')
      }
    }
  }, [_vm._v("\n\t\t\t\tEstadística\n\t\t\t")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-tab",
    class: {
      'active': _vm.$route.name === 'companies-history'
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.goTo('history')
      }
    }
  }, [_vm._v("\n\t\t\t\tHistorial\n\t\t\t")])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73ac834a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/companies/companies-statistics.vue
// module id = 1671
// module chunks = 72